import axios from '../config/axiosConfig';

/* Elenco delle simulazioni che usciranno in futuro */
export const listUpcomingReleases = async () => {
  try {
    const response = await axios.post('/api/simulations/listUpcoming');
    return response.data;
  } catch (error) {
    console.error('Error fetching upcoming releases: ', error);
    throw error;
  }
};

/* Elenco delle simulazioni già vendibili */
export const listSimulations = async () => {
  try {
    const response = await axios.post('/api/simulations/listAll');
    return response.data;
  } catch (error) {
    console.error('Error fetching simulations: ', error);
    throw error;
  }
};

/* Elenco delle simulazioni già vendibili */
export const listSimulationsSalable = async () => {
  try {
    const response = await axios.post('/api/simulations/listSalable');
    return response.data;
  } catch (error) {
    console.error('Error fetching simulations: ', error);
    throw error;
  }
};
